import React, {useContext, useEffect, useState} from 'react';
import {Grid, Typography} from '@mui/material';
import {PinDrop} from '@mui/icons-material';
import '../../../css/components/backToSearch.css'
import InstantApprovalChip from '../search/InstantApprovalChip';
import RequestSpaceChip from '../search/RequestSpaceChip';
import {AppContext} from "../../../context/app-context";
import {isBuyerAccountType} from '../../../util/AccountUtils';
import LocationFavoriteIcon from '../LocationFavoriteIcon';
import {styled} from "@mui/material/styles";
import {geoLine} from './LocationProfileSEO';

const LocationProfileGoBackLocationName = styled(Typography)(({theme}) => ({
    ...theme.components.contentTitleText,
    fontWeight: '600',
    fontSize: '1.43em'
}));

const LocationProfileWFitContent = styled('div')(() => ({
    width: 'fit-content',
}));

const LocationProfileCityState = styled(Typography)(() => ({
    fontSize: '1em'
}));

const LocationProfileSpaceTop = styled(Grid)(({theme}) => ({
    marginTop: '0.3rem',
    [theme.breakpoints.down('sm')]: {
        marginBottom: '0.5em',
    }
}));

const LocationProfileHeader = (props) => {
    const appContext = useContext(AppContext)
    const [locationAddress, setLocationAddress] = useState('');

    const { locationId, locationName, city, state, hasRequestedCapacity } = props;

    useEffect(() => {
        // "Truck parking & container storage · Pooler, GA" — same line the meta
        // description ends with, so the visible page and the snippet agree.
        // Blank while the location is still loading.
        setLocationAddress(city || state ? geoLine(city, state) : '');
    }, [city, state]);

    return (
        <header className='w-100'>
            <Grid container alignItems='center' className="ss-search-results-go-back-parent">
                <Grid container direction='column' className="ss-search-results-go-back-container w-100">
                    <LocationProfileGoBackLocationName component='h1'>
                        {locationName}
                    </LocationProfileGoBackLocationName>
                    <LocationProfileSpaceTop container justifyContent='space-between' alignItems='center'>
                        <Grid item>
                            <Grid container alignItems='center'>
                                <PinDrop fontSize='small' className="ss-search-results-pindrop-go-back" />
                                <LocationProfileCityState variant="subtitle2" color="textPrimary">
                                    {locationAddress}
                                </LocationProfileCityState>
                            </Grid>
                        </Grid>
                        <Grid item>
                            <Grid item container>
                                {
                                    isBuyerAccountType(appContext?.user?.type) &&
                                        <Grid item sx={{ mt: -1 }}>
                                            <LocationFavoriteIcon locationId={locationId} />
                                        </Grid>
                                }
                                <Grid item>
                                    <LocationProfileWFitContent>
                                        { hasRequestedCapacity ? <InstantApprovalChip /> : hasRequestedCapacity != null ? <RequestSpaceChip /> : null }
                                    </LocationProfileWFitContent>
                                </Grid>
                            </Grid>
                        </Grid>
                    </LocationProfileSpaceTop>
                </Grid>
            </Grid>
        </header>
    );
};

export default LocationProfileHeader;
